import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { Link } from 'react-router-dom'
import LocatedMenu from '../containers/LocatedMenu'
import PostThumb from '../containers/PostThumb'
import CustomLayout from '../custom/components/Layout'

class LangMemu extends Component {
  render() {
    return (
      <div>
        <Link to="/pl">PL</Link> | <Link to="/en">EN</Link> ( {this.props.t('currentLng')} )
      </div>
    )
  }
}

const LangMemuContainer = translate()(LangMemu)

const Layout = ({children, contentClassName, mediaId, title}) => (
  <div className={"container-fluid app" + (contentClassName ? " " + contentClassName : "")}>
    <div className="row app-header">
      <div className="col">
        <h1 className="app-title">{title}</h1>
        {mediaId ? <PostThumb size="full" mediaId={mediaId} /> : null}
        <LocatedMenu location="topMenuLocation" />
        <LangMemuContainer />
      </div>
    </div>
    <div>
      {children}
    </div>
  </div>
)

export default CustomLayout || Layout



// WEBPACK FOOTER //
// ./src/components/Layout.js